"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETED = exports.UPDATED = exports.NEW = void 0;
exports.NEW = 'NEW';
exports.UPDATED = 'UPDATED';
exports.DELETED = 'DELETED';
